// extracted by mini-css-extract-plugin
module.exports =  {"search-results":"s5pBByH","searchResults":"s5pBByH"};